import { render } from "./ExportImportUsers.vue?vue&type=template&id=9022153c&scoped=true"
import script from "./ExportImportUsers.vue?vue&type=script&lang=js"
export * from "./ExportImportUsers.vue?vue&type=script&lang=js"

import "./ExportImportUsers.vue?vue&type=style&index=0&id=9022153c&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9022153c"]])

export default __exports__